import React from "react";
import { PeekListItem, PeekListItemButton, PeekListItemText, PeekStack, useTheme, } from "@piiqtechnologies/ui-components";
export const NavigationListItem = ({ label, icon, isActive, className, disabled, onClick, }) => {
    const theme = useTheme();
    // Was `!overlayOpen && isActive`, with a forceActive prop to opt out of it: with billing and
    // settings as routes, only one page is active at a time and nothing needs to dim the others.
    const effectiveActive = isActive;
    return (React.createElement(PeekListItem, { key: label, disablePadding: true, className: className },
        React.createElement(PeekListItemButton, { onClick: onClick, disabled: disabled, sx: {
                backgroundColor: effectiveActive ? theme.palette.teal[100] : "initial",
                borderRadius: 1,
                height: theme.spacing(3.6),
                pl: 1,
                ml: -1,
            } },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
                icon,
                React.createElement(PeekListItemText, { primary: label, primaryTypographyProps: {
                        variant: "body1",
                        fontWeight: effectiveActive ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
                    } })))));
};
export default NavigationListItem;
